// Uclean-Admin-Dashboard/src/mocks/promo/promoCodes/handlers.js

import { http, HttpResponse } from 'msw';
import { BASE } from '../_shared/base';
import { paginate } from '../_shared/pagination';
import { validationError } from '../_shared/errors';
import { codesStore } from './store';

const ROOT = `${BASE}/promo-codes`;

function normalizeCode(raw) {
  if (typeof raw !== 'string') return '';
  return raw.normalize('NFKC').trim().toUpperCase();
}

export const promoCodesHandlers = [
  http.get(ROOT, ({ request }) => {
    const url = new URL(request.url);
    const promotionId = url.searchParams.get('promotion_id');
    let rows = codesStore;
    if (promotionId) rows = rows.filter((c) => c.promotion_id === promotionId);
    return HttpResponse.json(paginate(rows, {
      page: url.searchParams.get('page'),
      perPage: url.searchParams.get('per_page') || 50,
    }));
  }),

  http.post(ROOT, async ({ request }) => {
    const body = await request.json();
    const normalized = normalizeCode(body.code);
    if (!normalized) {
      return validationError({ code: ['The code field is required.'] });
    }
    const row = {
      id: `c-${Date.now()}`,
      uses_count: 0,
      status: 'active',
      max_uses: 1,
      expires_at: null,
      ...body,
      code: normalized,
    };
    codesStore.push(row);
    return HttpResponse.json({ data: row }, { status: 201 });
  }),

  // Engine semantics: DELETE soft-revokes (status flip), never removes
  // the row — redemptions reference it for audit.
  http.delete(`${ROOT}/:id`, ({ params }) => {
    const row = codesStore.find((c) => c.id === params.id);
    if (!row) return new HttpResponse(null, { status: 404 });
    row.status = 'revoked';
    return HttpResponse.json({ data: row });
  }),
];
